<script>
import { jumpLink } from '@/assets/js/util'
const DoubleBtn = {
  props: ['btns'],
  name: 'DoubleBtn',
  methods: {},
  render (createElement, context) {
    let vm = this
    const divStyle = {
      position: 'absolute',
      bottom: '0',
      width: '100%',
      height: `${200 / 200}rem`,
      textAlign: 'center'
    }
    const btnStyle = {
      objectFit: 'cover',
      display: 'inline-block',
      width: `${250 / 200}rem`,
      // height: `${106 / 200}rem`,
      fontSize: `${30 / 2}rem`,
      margin: `0 ${10 / 100}rem`
    }
    return createElement(
      'div',
      {
        style: {
          ...divStyle
        },
        class: {
          btnImgDiv: true
        }
      },
      this.btns.map(function (item) {
        return createElement('img', {
          style: {
            ...btnStyle
          },
          attrs: {
            src: item.btnPicUrl
          },
          on: {
            click () {
              if (Number(item.btnType) === 1) {
                jumpLink({
                  vm: vm,
                  url: item.btnUrl
                })
              } else {
                vm.$emit('close', item)
              }
            }
          }
        })
      })
    )
  }
}

const BigBtn = {
  props: ['btns'],
  name: 'BigBtn',
  methods: {},
  render (createElement, context) {
    let vm = this
    const divStyle = {
      position: 'absolute',
      bottom: '0',
      width: '100%',
      height: `${200 / 200}rem`,
      textAlign: 'center'
    }
    const btnStyle = {
      objectFit: 'cover',
      display: 'inline-block',
      maxWidth: '100%',
      maxHeight: '100%',
      fontSize: `${36 / 2}rem`,
      width: '100%'
    }
    return createElement(
      'div',
      {
        style: {
          ...divStyle
        },
        class: {
          btnImgDiv: true
        }
      },
      this.btns.map(function (item) {
        return createElement('img', {
          style: {
            ...btnStyle
            // backgroundImage: `url(${item.btnPicUrl})`,
          },
          attrs: {
            src: item.btnPicUrl
          },
          on: {
            click () {
              if (Number(item.btnType) === 1) {
                jumpLink({
                  vm: vm,
                  url: item.btnUrl
                })
              } else {
                vm.$emit('close', item)
              }
            }
          }
        })
      })
    )
  }
}

const CloseBtnDefault = {
  name: 'CloseBtnDefault',
  methods: {},
  render (createElement, context) {
    let vm = this
    const btnStyle = {
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      width: `${60 / 200}rem`,
      height: `${60 / 200}rem`,
      borderRadius: '50%',
      position: 'absolute',
      left: '50%',
      marginLeft: `-${60 / 200 / 2}rem`,
      bottom: `-${150 / 200}rem`,
      backgroundImage: `url(${require('../../assets/images/icon-close-3.png')})`
    }
    return createElement('div', {
      style: {
        ...btnStyle
      },
      on: {
        click: function () {
          vm.$emit('close')
        }
      }
    })
  }
}

const CloseBtn1 = {
  props: ['btns'],
  name: 'CloseBtn1',
  methods: {},
  render (createElement, context) {
    let vm = this
    const btnStyle = {
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      width: `${40 / 200}rem`,
      height: `${40 / 200}rem`,
      position: 'absolute',
      right: `${12 / 200}rem`,
      top: `${12 / 200}rem`
    }
    return createElement('div', {
      style: {
        backgroundImage: `url(${
          Number(this.btns.closeBtnCss) === 3
            ? this.btns.closeBtnPicUrl
            : require('../../assets/images/icon-close-2.png')
        })`,
        ...btnStyle
      },
      on: {
        click: function () {
          vm.$emit('close')
        }
      }
    })
  }
}

export default {
  name: 'compositePopup',
  components: {
    DoubleBtn,
    BigBtn,
    CloseBtnDefault,
    CloseBtn1
  },
  props: ['data'],
  mounted () {
    this.showPopup()
  },
  methods: {
    close (item) {
      this.$emit('closeCompositePopup')
    },
    showPopup () {
      // 在活动中返回首页时不显示入口弹窗
      if (this.$route.query.isActivityBack === '1') {
        return false
      }
      // 判断是否有活动
      if (!this.data['popub']) {
        return false
      }

      if (this.$route.query.composite_popup_id) {
        return true
      }
      // 一天只弹一次
      let date = new Date()
      if (
        localStorage.getItem('compositePopup') &&
        localStorage.getItem('compositePopup') ===
          `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`
      ) {
        return false
      } else {
        localStorage.setItem(
          'compositePopup',
          `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`
        )
      }

      return true
    },

    getBtnType (data) {
      // 判断单双按钮
      if (Number(data.type) === 1) {
        return <BigBtn btns={data.buttons} onClose={this.close} />
      }

      if (Number(data.type) === 2) {
        return <DoubleBtn btns={data.buttons} onClose={this.close} />
      }
    },

    getCloseBtnType (data) {
      if (Number(data.closeBtnCss) === 1) {
        return <CloseBtnDefault onClose={this.close} />
      } else {
        return <CloseBtn1 onClose={this.close} btns={data} />
      }
    }
  },
  render () {
    let showPopup = this.showPopup()
    if (!showPopup) {
      // 如果没有活动则不展示弹窗
      return
    }
    let data = this.data.popub
    let result = []
    var vm = this
    result.push(this.getBtnType(data))
    result.push(this.getCloseBtnType(data))
    let components = <div class="relative">{result}</div>
    return (
      <div class="composite-body">
        <div class="composite-popup">
          <img src={data.bgPicUrl} />
          {result}
        </div>
        <div class="composite-overflow"></div>
      </div>
    )
  }
}
</script>

<style lang="less" scoped>
.composite-body {
  position: fixed;
  z-index: 2000;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  .composite-popup {
    position: relative;
    z-index: 2;
    text-align: center;
    max-width: 600/200rem;
    max-height: 720/200rem;
    text-align: center;
    margin: 250/200rem auto 0 auto;
    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }
  .relative {
    position: relative;
    width: 100%;
    height: 100%;
  }
  .composite-overflow {
    position: fixed;
    z-index: 1;
    height: 100%;
    width: 100%;
    left: 0;
    bottom: 0;
    right: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.6);
  }
  .btnImgDiv {
    display: flex;
    align-items: flex-end;
  }
}
</style>
